<nz-list nzBordered>
  @for (item of userAgreements(); track item) {
    <nz-list-item>
      <div>
        <div nz-typography>{{ item.agreement.title }}</div>
        <div class="text-gray-500 text-sm">
          {{ item.agreedAt | date: 'dd/MM/yyyy HH:mm' }}
        </div>
      </div>
      <a nz-button nzType="text" [href]="item.pdfUrl" target="_blank" rel="noopener noreferrer" download>
        <i nz-icon nzType="download"></i>
      </a>
    </nz-list-item>
  }
</nz-list>
